import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography, { COLORS } from 'Components/UI/Typography';

const styles = theme => ({
  root: {
    minHeight: 16,
    fontSize: theme.typography.body2.fontSize,
    flexShrink: 1,
  },
});

const getNoWrap = ({
  noWrap = true,
}) => {
  return noWrap;
};

const getHelperTextAndColor = ({
  helperText,
  color,
  metaField = null,
  saving,
  isDirty,
  displaySuccess,
  displayFailure,
  showRequiredHelperText = true,
  showOptionalHelperText = false,
  showHelperTextOnInlineSubmit = true,
}) => {
  if (helperText) {
    return [helperText, color];
  }

  if (saving && showHelperTextOnInlineSubmit) return ['Saving...', 'inherit'];

  if (displaySuccess && showHelperTextOnInlineSubmit) return ['Saved successfully', 'secondary'];

  if (isDirty && showHelperTextOnInlineSubmit) return ['Unsaved changes', 'orange'];

  if (displayFailure && showHelperTextOnInlineSubmit) return ['Failed to save.', 'error'];

  if (showRequiredHelperText && metaField?.attr('required')) return ['* Required', 'error'];

  if (showOptionalHelperText && !metaField?.attr('required')) return ['Optional', 'inherit'];

  return [' ', 'inherit'];
};

function HelperText({ classes, ...rest }) {
  const [text, color] = getHelperTextAndColor(rest);
  const noWrap = getNoWrap(rest);
  return <Typography noWrap={noWrap} className={classes.root} color={color} component="span">{text}</Typography>;
}

HelperText.defaultProps = {
  color: 'inherit',
};

HelperText.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(COLORS),
};

export default withStyles(styles)(HelperText);
